module.exports = __webpack_public_path__ + "f50495dba2e0bd010cc3f76e1e2980f5.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/v-2-logo.png
// module id = 632
// module chunks = 0